/* src/app/core/shared/components/employee-role-badge/employee-role-badge.component.css */
.role-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 104px;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
  border: 1px solid transparent;
}
.role-owner {
  background: #f3e8ff;
  color: #7e22ce;
  border-color: #e9d5ff;
}
.role-administrator {
  background: #dbeafe;
  color: #1d4ed8;
  border-color: #bfdbfe;
}
.role-worker {
  background: #dcfce7;
  color: #15803d;
  border-color: #bbf7d0;
}
.role-unknown {
  background: #f1f5f9;
  color: #475569;
  border-color: #e2e8f0;
}
/*# sourceMappingURL=employee-role-badge.component.css.map */
